export default "__VITE_ASSET__D8pv_5yL__"